import React, { Component, Fragment } from 'react';
import { MD5 } from "../../helpers/md5";
import { APP_SECRET, APP_ID } from "../../constants/Config";
import { BASE_URL_API } from "../../constants/Common";
import { callApiComment } from "../../helpers/ApiComment";
import { IsJsonString } from "../../helpers/StringHelper";

import TimeAgo from 'timeago-react';
// import timeago from 'timeago.js';
import './comment.css';

class CommentDetailMedia extends Component {

    constructor(props) {
        super(props);
        this.state = {
            count_comment: 0,
            comments: [], // list comment display
            mod: false, // grant permission comment
            number_after: -1, // loadmore
            number_before: -1, // loadmore
            last_id_comment: -1, // loadmore
            content_parent: "", // content parent input for current user
            content_children: "", // content children input for current user
            reply_to: { post_id_reply: -1, users_tag: [] }, // user {name, uniqid, avatar}
        }
        this.user_comment = -1
        this.post_id = -1;
        this.conversation_id = -1;
        this.token_comment = null;
        this.currentUrl = props.currentUrl;
        this.timestamp = Date.now();
        this.checksum = MD5(APP_SECRET + this.timestamp);
        this.token = localStorage.getItem('token_user');

        this.apiConnectComment();
        // timeago.register('vi', require('timeago.js/locales/vi'));
    }

    addCommentToState = (comment) => { // just update layout by state
        let array = [...this.state.comments];
        if (parseInt(comment.parent_id, 10) === parseInt(this.post_id, 10)) { // comment lv == 1
            array.unshift(comment);
        } else {
            let length = array.length;
            for (let i = 0; i < length; i++) {
                let _comment = array[i];
                if (parseInt(comment.parent_id, 10) === parseInt(_comment.id, 10)) {
                    _comment.content_reply.push(comment);
                }
            }
        }
        this.setState({
            count_comment: this.state.count_comment + 1,
            comments: array,
            content_parent: "",
            content_children: "",
        })
    }

    updateCommentVote = (comment_id, comments, up = true) => { // just update layout by state
        for (let i = 0; i < comments.length; i++) {
            if (parseInt(comments[i].id, 10) === parseInt(comment_id, 10)) {
                up === true ? comments[i].number_vote++ : comments[i].number_vote--;
                if (up === true) {
                    let array = [...comments[i].list_vote];
                    array.push(this.user_comment);
                    comments[i].list_vote = array;
                } else {
                    let array = [...comments[i].list_vote]
                    let index = array.indexOf(this.user_comment);
                    array.splice(index, 1);
                    comments[i].list_vote = array;
                }
            }
            if (parseInt(comments[i].level, 10) === 1) {
                this.updateCommentVote(comment_id, comments[i].content_reply, up)
            }
        }

        this.setState({
            comments: comments
        })
    }

    apiPost = (to, users_tag) => {
        let post_id = parseInt(this.post_id, 10);
        to = parseInt(to, 10);
        let mentions = [];

        users_tag.map(user => {
            return mentions.push(`{"text" : "@${user.name}", "uid"  : "${user.uniqid}", "src" : "${user.avatar}"}`);
        });

        let data = new FormData();
        let content = (parseInt(to, 10) === parseInt(post_id, 10)) ? this.state.content_parent : this.state.content_children;
        let content_param = `{"content":[{"type":"text", "data_text": ${JSON.stringify(content)}}], "mention": ${JSON.stringify(mentions)}}`;

        data.append('token', this.token_comment);
        data.append('app_id', APP_ID);
        data.append('post_id', post_id);
        data.append('checksum', this.checksum);
        data.append('content', content_param);
        data.append('url_base', this.currentUrl);
        data.append('timestamp', this.timestamp);
        data.append('parent_id', to);

        callApiComment(`${BASE_URL_API}/post`, data)
            .then((response) => {
                if (response.data.meta.signal === 1) {
                    this.addCommentToState(response.data.data.data)
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    apiGetDataComment = () => {
        let data = new FormData();
        data.append('app_id', APP_ID);
        data.append('content_url', this.currentUrl);
        data.append('checksum', this.checksum);
        data.append('token', this.token_comment);
        data.append('post_id', this.post_id);
        data.append('timestamp', this.timestamp);

        callApiComment(`${BASE_URL_API}/getDataComment`, data)
            .then(response => {
                if (response.data.meta.signal === 1) {
                    let result = response.data.data;
                    this.setState({
                        comments: result.data,
                        mod: result.mod,
                        number_after: result.number_after,
                        number_before: result.number_after,
                        last_id_comment: result.data.length > 0 ? result.data[result.data.length - 1].id : -1
                    })
                }
            }).catch(error => {
                console.log(error);
            })
    }

    apiInitComment = () => {
        let data = new FormData();
        data.append('app_id', APP_ID);
        data.append('content_url', this.currentUrl);
        data.append('checksum', this.checksum);
        data.append('token', this.token_comment);
        data.append('timestamp', this.timestamp);

        callApiComment(`${BASE_URL_API}/initComment`, data)
            .then((response) => {
                if (response.data.meta.signal === 1) {
                    let result = response.data.data;
                    this.post_id = result.post_id
                    this.conversation_id = result.conversation_id
                    this.setState({
                        count_comment: result.count_comment
                    })
                    this.apiGetDataComment();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    apiConnectComment = () => {
        let data = new FormData();
        data.append('checksum', this.checksum);
        data.append('token', this.token);
        data.append('timestamp', this.timestamp);

        callApiComment(`${BASE_URL_API}/connectComment`, data)
            .then(response => {
                if (response.data.meta.signal === 1) {
                    let token = response.data.data.token;
                    let user_comment = response.data.data.user_comment;
                    this.token_comment = token;
                    this.user_comment = user_comment;
                    this.apiInitComment();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    apiLoadMore = () => {
        let data = new FormData();
        data.append('token', this.token);
        data.append('app_id', APP_ID);
        data.append('post_id', parseInt(this.post_id, 10));
        data.append('checksum', this.checksum);
        data.append('last_id', this.state.last_id_comment);
        data.append('parent_id', this.state.last_id_comment);
        data.append('timestamp', this.timestamp);

        callApiComment(`${BASE_URL_API}/loadMore`, data)
            .then(response => {
                if (response.data.meta.signal === 1) {
                    let result = response.data.data;
                    console.log(result.data)
                    this.setState({
                        comments: [...this.state.comments, ...result.data],
                        number_after: result.number_after,
                        number_before: result.number_after,
                        last_id_comment: result.data[result.data.length - 1].id
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    replyTo = (to, users_tag) => {
        to = parseInt(to, 10);
        this.setState({
            reply_to: { post_id_reply: to, users_tag: users_tag }
        })
    }

    voteDownPost = (comment_id) => {
        let data = new FormData();
        data.append('token', this.token_comment);
        data.append('app_id', APP_ID);
        data.append('post_id', parseInt(comment_id, 10)); // Id của comment được vote
        data.append('checksum', this.checksum);
        data.append('conversation_id', this.conversation_id);
        data.append('timestamp', this.timestamp);

        this.updateCommentVote(comment_id, [...this.state.comments], false);

        callApiComment(`${BASE_URL_API}/voteDownPost`, data)
            .then(response => {
                if (response.data.meta.signal === 1) {
                }
            })
            .catch(function (error) {
                this.updateCommentVote(comment_id, [...this.state.comments], true);
                console.log(error);
            });
    }

    voteUpPost = (comment_id) => {
        let data = new FormData();
        data.append('token', this.token_comment);
        data.append('app_id', APP_ID);
        data.append('post_id', parseInt(comment_id, 10)); // Id của comment được vote
        data.append('checksum', this.checksum);
        data.append('conversation_id', this.conversation_id);
        data.append('timestamp', this.timestamp);

        this.updateCommentVote(comment_id, [...this.state.comments], true);

        callApiComment(`${BASE_URL_API}/voteUpPost`, data)
            .then(response => {
                if (response.data.meta.signal === 1) {
                }
            })
            .catch(function (error) {
                this.updateCommentVote(comment_id, [...this.state.comments], false);
                console.log(error);
            });
    }

    generateButtonLoadMore = () => {
        return (
            this.state.number_after > 0 ? (<div className="text-center watch-more-cmmt">
                <button onClick={this.handleLoadMore} >Tải thêm bình luận</button>
            </div>) : null
        )
    }

    handleLoadMore = () => {
        this.apiLoadMore();
    }

    handleSubmit = (to, users_tag) => {
        if (this.state.content_parent || this.state.content_children) {
            this.apiPost(to, users_tag);
        } else {
            console.log("Nội dung không được để trống"); // todo thông báo error kiểu khác
        }
    }

    handleChangeContent = (e) => {
        let name = e.target.name;
        let value = e.target.value;

        if (name === "content_children") {
            this.setState({
                content_parent: "",
                content_children: value
            })
        }
        if (name === "content_parent") {
            this.setState({
                content_parent: value,
                content_children: ""
            })
        }
    }

    deleteTag = () => {
        let { post_id_reply } = this.state.reply_to;
        this.setState({
            reply_to: { post_id_reply, users_tag: [] }
        })
    }

    genreateTagUser = (users_tag) => {
        return users_tag.map((user, index) => {
            return (
                <div className="tag" key={index}>
                    <span>{user.name}</span>
                    <button className="deleteTag" onClick={this.deleteTag}>
                    </button>
                </div>
            )
        });
    }

    generateComments = (commentsInput) => {
        let comments = commentsInput ? commentsInput : [...this.state.comments];
        if (comments.length === 0) return;

        return comments.map((comment, index) => {
            let firstClass = parseInt(comment.level, 10) === 1 ? "message-boxKT-parent" : "message-boxKT-children";

            let content = "";
            let contentJson = comment.content;

            if (IsJsonString(contentJson)) {
                let content_array = JSON.parse(contentJson, false);

                if (!!content_array.mention && content_array.mention.length > 0) {
                    for (let itemMentions of content_array.mention) {
                        let parseItem = JSON.parse(itemMentions);
                        content += "<strong>" + parseItem.text + "</strong> ";
                    }
                }

                if (!!content_array.content && content_array.content.length > 0) {
                    for (let itemContent of content_array.content) {
                        content += itemContent.data_text + " ";
                    }
                }
            }
            return (
                <Fragment key={index}>
                    <div className={firstClass}>
                        <div className="pull-left container-avatar">
                            <a>
                                <img src={comment.avatar} alt={comment.name} className="img-responsive" />
                            </a>
                        </div>
                        <div className="container-content-mes">
                            <div className="name-mes">
                                <div role="button" className="name">
                                    <span>{comment.name}</span>
                                </div>
                            </div>
                            <div className="clearfix content-mess">
                                <div dangerouslySetInnerHTML={{ __html: content }} />
                            </div>
                            <div className="content-time-reply">
                                <a role="button" className="like" onClick={
                                    () => [...comment.list_vote].indexOf(this.user_comment) === -1 ? this.voteUpPost(comment.id) : this.voteDownPost(comment.id)}
                                >{[...comment.list_vote].indexOf(this.user_comment) === -1 ? "Thích" : "Bỏ thích"}</a>{"."}
                                <a role="button" className="reply" onClick={
                                    () => this.replyTo(
                                        parseInt(comment.level, 10) === 1 ? comment.id : comment.parent_id,
                                        parseInt(comment.level, 10) === 1 ? [] : [{ name: comment.name, uniqid: comment.uniqid, avatar: comment.avatar }]
                                    )
                                }>Phản hồi</a>{"."}
                                {comment.number_vote !== 0 ? <Fragment><div className="vote">
                                    <img src="/images/like.png" alt="like" /><span>{" " + comment.number_vote}</span>
                                </div>{"."}</Fragment> : null}

                                <TimeAgo
                                    className="time"
                                    live={false}
                                    datetime={comment.created}
                                    locale='vi' />
                            </div>
                        </div>
                    </div>
                    {comment.content_reply.length > 0 ? this.generateComments(comment.content_reply) : null}
                    {parseInt(comment.id, 10) === parseInt(this.state.reply_to.post_id_reply, 10) ? <div className="clearfix CVKInputContainer childrenInput">
                        <div className="pull-right action-send">
                            <a onClick={() => this.handleSubmit(this.state.reply_to.post_id_reply, this.state.reply_to.users_tag)}>
                                <span className="fa fa-paper-plane" />
                            </a>
                        </div>
                        <div className="action-ipn form-control add-comment-input-wraper">
                            {this.genreateTagUser([...this.state.reply_to.users_tag])}
                            <input
                                id="content-child"
                                type="text"
                                className="add-comment-input"
                                name="content_children"
                                placeholder="Viết bình luận..."
                                onChange={this.handleChangeContent}
                                onKeyPress={event => {
                                    if (event.key === "Enter") {
                                        this.handleSubmit(this.state.reply_to.post_id_reply, this.state.reply_to.users_tag);
                                    }
                                }}
                                value={this.state.content_children} />
                        </div>
                    </div> : null}

                </Fragment>
            )
        })
    }

    render() {
        return (
            <div className="comment-vietid-kt">
                <div className="CVK-input-count-wrap">
                    {this.state.count_comment > 0 ? <div className="count-comment">
                        <span>{this.state.count_comment} bình luận</span>
                    </div> : null}
                    <div className="clearfix CVKInputContainer">
                        <div className="pull-right action-send">
                            <a onClick={() => this.handleSubmit(this.post_id, [])}>
                                <span className="fa fa-paper-plane" />
                            </a>
                        </div>
                        <div className="action-ipn">
                            <input
                                type="text"
                                className="form-control"
                                name="content_parent"
                                placeholder="Viết bình luận"
                                onChange={this.handleChangeContent}
                                onKeyPress={event => {
                                    if (event.key === "Enter") {
                                        this.handleSubmit(this.post_id, []);
                                    }
                                }}
                                value={this.state.content_parent} />
                        </div>
                    </div>
                </div>
                <div className="CVK-content">
                    <div className="clearfix message-boxKT">
                        {this.generateComments()}
                    </div>
                    {this.generateButtonLoadMore()}
                </div>
            </div>
        )
    }
}

export default CommentDetailMedia;



// WEBPACK FOOTER //
// ./src/components/Comment/CommentDetailMedia.js